module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "1. Rooted: A Contingent Look at Polish Jews in the Late 1930s"
    }
  }, [_c('p', {
    staticClass: "chap_num",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Contents#rsec3"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "chimg"
  }, [_c('img', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "alt": "",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap_title"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Contents#rsec3"
    }
  }, [_vm._v("ROOTED")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_stitle"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253064967_Contents#rsec3"
    }
  }, [_vm._v("A Contingent Look at Polish Jews in the Late 1930s")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LATE IN THE EVENING OF")]), _vm._v(" August 10, 1936, the Polish Jewish engineer Anselm Reiss read an unexpected declaration to the inaugural event of the World Jewish Congress in Geneva. This meeting, a networking opportunity full of welcome messages and self-congratulations for eight hundred delegates from all over the globe, included committee meetings and planned speeches, such as those from the high commissioner for refugees coming from Germany, Sir Neill Malcolm, and WJC leaders Stephen Wise, Nahum Goldman, and Maurice Perlzweig. But Reiss, the voice of some fifty Polish delegates from often-sparring political parties and more than three million Jews who had Polish citizenship, temporarily stole the show with a simple message: Polish Jews belonged in Poland."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poland had been built by Jews, he said, and Jews had shed their blood and grown as a community in Poland “for hundreds of years.” Poland’s Jews possessed the “unquestionable right like other citizens, under the protection of the state and the law, to life, to peace and to work freely,” and despite vitriolic antisemitic political propaganda and discriminatory economic initiatives, they refused to be “terrorized” into leaving. To his colleagues from the rest of Europe, Reiss highlighted the ostensible unity of Polish Jewry, in whose struggle they expected to find support from the whole of Jewish people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lively and long applause” coursed through the assembly. Afterward, Nahum Goldmann, a leader of the World Jewish Congress, congratulated Reiss and his Polish Jewish colleagues on their “unified political declaration.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Those “familiar with the internal Jewish situation in Poland,” Goldmann said, would consider the first World Jewish Congress a success if it managed “to unite the various parties and currents of Polish Jewry.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Goldmann continued to speak "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("in vague language. Despite being offered at a time of “diversity and strife,” the Polish Jewish declaration signified a potential “commonality that transcended politics, class, gender and religious belief.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("WJC members assembled in Geneva were not the only listeners supportive of Reiss’s declaration. Three days later, a regular contributor to the popular Polish-language Jewish daily "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v("—“N.S.”—championed Reiss’s proclamation as a “blatant expression” of the “views which prevail among the widest masses of Polish Jewry.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" N.S. contrasted the Geneva declaration to a statement from Yitzhak Grünbaum, a Zionist who had left Poland for Palestine in the early 1930s. At a press conference a month earlier, Grünbaum had said that “‘the hour of exodus from Poland had struck,’” provoking a “barrage of criticism both from his political friends and foes” but echoing remarks by Revisionist Zionist leader Vladimir Jabotinsky."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Earlier that month, Jabotinsky had penned a missive to Polish foreign minister Józef Beck suggesting that Poland should urge British Mandate authorities in Palestine to adopt a constructive plan for the peaceful “exodus” of nearly seven hundred thousand “Polish Jewish immigrants to Palestine” as soon as possible in the name of “humanitarian principles and its own political interests.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" The views of Jabotinsky, Beck, and Grünbaum were misleading, according to N.S. In his view, most Polish Jews subscribed to Reiss’s protest against the mass emigration of Jews from Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inspired by this statement and others that seem to contradict it, I explore the “rootedness” of Polish Jews in interwar Poland and show how discussions casting emigration as a solution to Jewish, peasant, or economic “problems” in Poland in fact did not translate into viable plans."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" I consider critically the claim that migration might have improved the lot of Polish Jews or others in the economically depressed Second Republic, as antisemites, Revisionists, and state demographers claimed in the 1920s and 1930s. In the end, members of the World Jewish Congress and the Jews whom they wanted to represent remained committed to the diaspora, despite the dire geopolitical context, despite calls to coordinate emigration opportunities away from homelands throughout east central Europe, and, for some, despite their broadly conceived commitment to Jewish settlement in Palestine."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Talk of “evacuation,” Jabotinsky’s demands for wide-scale exodus (from hundreds of thousands to millions) of Jews from Europe, or calls for the “negation of the diaspora” threatened the essence of the World Jewish Congress’s platform and prompted officials working for the WJC to take action.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Drawing on sociologist Małgorzata Melchior’s theory of “rootedness,” I explore the writings of five men: Arieh Tartakower, a sociologist, activist, and member of the WJC Office Committee who lived in Poland for most of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("the interwar period; James McDonald, a diplomat who was appointed by the League of Nations as the first high commissioner for refugees (Jewish and others) from Germany; Jewish American Baruch Zuckerman, who took a WJC-led trip to Poland in 1937 and 1938; Jakob Apenszlak, an editor of and contributor to "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v("; and, finally, Joel Cang, a Polish Jewish journalist who wrote about minority politics, his country, and the region around it for the uncensored, English-language presses. These five men, along with a few other personalities connected to the World Jewish Congress, help us understand the “ethnic revolution” traced throughout this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE ROOTEDNESS OF POLISH JEWS IN THE LATE 1930S")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The World Jewish Congress convened in Geneva to organize the Jewish diaspora throughout the world. Yet because many Jews could trace their lineage back many centuries, we need to examine the word "), _c('i', [_vm._v("diaspora")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Were not Polish Jews, in fact, “rooted” in interwar Poland?"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" This rootedness took multiple forms: local, regional, and national; familial and communal; political, linguistic, and cultural; and logistical and emotional."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" As Melchior explains, a feeling of rootedness includes three essential attributes: an “awareness” of one’s own place in the world, “specific references” from a shared past that create a “sense of continuation,” and “knowledge” of origination, transmitted in social, historical, and cultural forms."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" And while rootedness is “hard to define,” observers such as Melchior and Simone Weil demand that we try. Being rooted, Weil wrote in the 1940s, “is perhaps the most important and least recognized need of the human soul.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" This “need” for rootedness remained as the 1930s progressed despite charged political debates in the Sejm about calls for Jews to leave Poland, despite a growing sense of pessimism about the continued viability of minority rights in the Polish Jewish press, and despite more manifestations of antisemitism. From the late 1930s, a significant cross section of Polish Jews—from politicians to historians, from keepers of taverns to those staffing stalls on market days, and from self-described “Zionists” to acculturating teenagers—were rooted in both place and memory, in the complicated Polish present, and in plans for the foreseeable future."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before and after Anselm Reiss and his colleagues claimed to speak for the collective of Polish Jews in Geneva, scholars of this complex collective sought to understand it, attribute adjectives to it, and recognize the diversity within it. Observations from the late interwar period and literature from subsequent years argue that nearly every Jew territorially or historically rooted in the lands "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("that became part of the Second Polish Republic had been “Polonized,” linguistically or otherwise, by the second half of the 1930s."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" And while some scholars have maintained that this was a population living in a “self-contained world within which it was possible, if one chose, to live almost without venturing into broader society,” others have emphasized a richer interpretation."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Contemporary Polish Jewish historians and their recent chronicler Natalia Aleksiun assert that significant interaction took place beyond financial transactions, resulting in a “cultural cross-fertilization” of Jewish and non-Jewish groups."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" In the Second Republic, linguistic, social, and cultural aspects of Polishness entered almost all Jewish spaces, from Hasidic prayer halls and observant homes to holiday resorts with kosher catering and the bustling coffeehouses frequented by Warsaw’s Jewish intellectuals."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" This embrace of Polish language and culture did not preclude separatism and the continuance of “Jewish difference,” which sometimes cost Jews their livelihoods and lives."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Undoubtedly, the Polish Jews alive in the 1930s saw that antisemitism could be used as a political tool and contribute to systematic discrimination and the outbreak of everyday violence."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Nevertheless, Jews built autonomous institutions, as well as their own linguistic universes, and created unique forms of cultural belonging that permeated what was probably the most diverse community of Jews on the planet."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their belonging to Polish geography did not, of course, inhibit spiritual ties, dreams, or, in even rarer cases, concrete plans to leave Poland at some point in the immediate or vaguely distant future. Despite his rejection of Zionism, Avraham Mordechai Alter of Ger, the third rebbe in that Hasidic dynasty, “supported buying land in Palestine” and even encouraged his followers to go there and establish institutions in his name."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Some Polish youth imagined futures in Palestine and elsewhere in YIVO autobiography contests in 1932, 1934, and 1939."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Hasidim and Orthodox Jewish leaders and parents found varying ways to come to terms with the increasingly secularized youth, who abandoned “religion” for Zionist and socialist groups in unprecedented numbers."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Marci Shore tells us that, despite being atheists and of different political stripes, all of the children of the prominent Berman family (including Zionist Adolf and Stalinist Jakub) convened faithfully at their parents’ Passover seder and promised to do the same “next year in Jerusalem” out of respect for their observant elders."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Jewish intellectuals took advantage of their abilities to travel extensively, live in France or the United States, or make aliyah when such possibilities existed."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-27"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Anselm Reiss attempted to begin a life in Palestine, yet like many of his peers, he returned to the country of his citizenship after a handful of years. The three-pronged concept of rootedness offered by Melchior "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("does not preclude these actions, nor should a concession of rootedness diminish the reality of sympathies that might be classified as Zionist.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, awareness of rootedness helps us better understand the different forms of Zionism that developed in Poland. Kamil Kijek has argued that the Polish patriotism that infused Polish Zionist culture as well as the school curriculum of the Zionist-supported Tarbut system “gave local Polish Zionism its own special flavor” that stood in contrast to Zionist cultures developing in Palestine or elsewhere."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-28"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Also in the 1930s, self-defined “Zionists” among public-facing Polish Jewish historians used their “understanding of Zionism as a form of diaspora nationalism” and their interpretation of the past “to envision a future in which Jews would be at home in Poland while maintaining a strong Jewish national identity and culture.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-29"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Directly before the Second World War, the Polish Jewish historian, rabbi, and Sejm member Mojżesz Schorr noticed that “even the most ardent Zionists are to some extent assimilated in the world of ideals ["), _c('i', [_vm._v("ideowo zasymilowani")]), _vm._v("]. Not only are the Polish writing skills of many of them excellent, but they encounter Polish culture beginning in their school years and [continuing] throughout their lives, and it affects them in all aspects of their spirit, in the sciences, art, and literature.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-30"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" All forms of Jewish nationalism active in interwar Poland took on striking Polish characteristics, even Palestine-centric forms of Zionism."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-31"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even the most revolutionary Zionists had to concede that a statistically significant diaspora would remain in Poland indefinitely. For example, when Vladimir Jabotinsky spoke at the Warsaw Society of Jewish Physicians and Engineers in late September 1936, the leader of Revisionist Zionism criticized those who suggested that his proposed evacuation scheme implied the transfer of all Polish Jews. Even if Mandate Palestine could absorb more than 50,000 Jews annually and the non-Jewish population within Poland increased naturally, the Polish Jewish diaspora would still number 2,792,000 ten years in the future."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-32"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Increasingly, geopolitical conditions further restricted short-term plans to settle sizeable numbers of east central European Jews as new restrictions imposed by British authorities came into effect during the late 1930s. Furthermore, on a fundamental level, even the so-labeled “Zionist masses” (in Poland, in east central Europe, or even in the United States) did not leave en masse, even when they had opportunities to do so."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-33"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Thus, although coverage of events in the Mandate permeated "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v(", the topic of Jewish settlement in Palestine dominated conversations among WJC officials, and international officials focused on refugee issues, east central European Jewish nationalists were not necessarily territorially monogamous in 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Around 3.1 million Polish citizens declared their allegiance to the Jewish faith in the official census taken in 1931."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Almost 400,000 of them listed Polish as their mother tongue."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-35"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" The census did not register bilingual or trilingual capacities, but one must, by the 1930s, assume a widespread knowledge of Polish among those who listed Yiddish or Hebrew as their language of everyday use."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-36"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" On top of this fact, responses to the question about “mother tongue” ("), _c('i', [_vm._v("język ojczysty")]), _vm._v(") sometimes became political declarations, especially for those designating Hebrew for this answer. Since that 1931 census, the population had grown, and worldwide emigration away from Poland had stalled. This population was increasingly young: 43.1 percent of these Polish Jews were under the age of twenty at the end of the 1930s."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-37"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" According to government data, more than 80 percent of Jewish school-age children in the upcoming 1937 school year planned to attend a state-run school."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-38"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" By the end of the 1930s, then, nearly half of the roughly 3.3-million-strong Jewish population had lived almost their entire lives in a Polish state, around the Polish language, imbricated in a Polish legal system, and cognizant of particular cultural signifiers that marked their time and place. And yet, the religious, cultural, linguistic, political, and economic diversity of this collective should not be overlooked, despite the monolithic unity presented by Anselm Reiss at Geneva and by some historians who speak of unified “Jewries” but in doing so simplify the heterogeneity of human groups.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Collective experiences and memories did congeal, of course. Undoubtedly, the Jewish population in the Second Republic, their parents, and their grandparents had been collectively impacted by the uncertainty, brutality, and massive displacement that accompanied the Great War (particularly on the Eastern Front), two Russian “Revolutions” in 1917, and the conflicts that raged until the Treaty of Riga in 1921."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-39"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" The initial advance of the Central Forces into the Russian Empire and Russian administration responses to this invasion, to cite at least one staggering statistic, initiated a (largely compulsory) mass movement of Jews, employees of evacuated factories, and other civilians that contributed to the registration of more than 3.1 million refugees in nonoccupied Russia in May 1916."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-40"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Others poured westward to Berlin and Prague or southward to Vienna. There, displaced, they learned about the 1917 Balfour Declaration, which stated that the British government looked with favor on “the establishment in Palestine of a national home for the Jewish people.” This event infused the generation-old World Zionist Organization and its diverse constituents with new hope but also new questions."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-41"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" In fact, Balfour’s letter offered little certainty in an uncertain time. Joseph Roth observed that it was “terribly hard to be an eastern Jew; there [was] no harder lot than that of the eastern Jew newly "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("arrived in Vienna.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-42"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Violence, displacement, and uncertainty continued long after the signing of peace treaties to end the Great War and the Polish-Soviet conflict."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-43"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" A startling pogrom in Lwów/L’viv/Lemberg in November 1918 preceded a “catastrophic pogrom wave,” which began in December 1918 in Ukraine and, by the end of 1919, had “claimed several tens of thousands of Jewish lives.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-44"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" As Ezra Mendelsohn reminds us, physical violence was “part of the scene” and thus an “important phenomenon which should be understood in the context of economic decline, of psychological despair and, perhaps, also of strong acculturating tendencies among the youth.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-45"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the Great War, Poland emerged on the map of Europe for the first time in more than a century and brought together territory, railroads, and populations from three different empires. Military gains under Józef Piłsudski extended Poland’s northeastern and eastern borders and resulted in the incorporation of a significant percentage of Ukrainians, Belarusians, Jews, and “local” inhabitants living under Polish governance. More than 30 percent of these new Polish citizens were not considered “Polish” according to two interwar censuses. The more than three million Jews who gained Polish citizenship belonged to different socioeconomic classes. They expressed their connection to Jewish law and Judaism in various ways. Interwar Poland brought together Hasidic leaders and their courts, which helped make the Orthodox population in this new state the largest in the region."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-46"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" The Jews in the Second Republic also belonged to a dizzying panoply of political organizations and parties."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-47"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" In Poland, “Zionists” and “Bundists” were not always in opposition, and an individual could claim allegiance to both “groups” simultaneously or over a political lifetime."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-48"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" “Non-Zionists” and “anti-Zionists” agreed only to a certain extent. In voting booths, “Jewish willingness to back the Bezpartyjny Blok Współpracy z Rządem, or BBWR, in the 1928 elections as well as other ‘Polish’ parties in Polish-majority settlements open[ed] the tantalizing possibility that for Jews, the prospect of political assimilation was real and not simply theoretical.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-49"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interwar reality does not always align with preconceptions that we carry, either consciously or unconsciously. As a case in point, some of the most “conservative” groups in Polish Jewish society seemingly utilized revolutionary methods in their schooling for young women."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-50"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Supporters of Polish-language schooling also sent their children to summer camps run by Zionist-leaning parties, contributed to shekel membership drives, and even traveled to meetings of the World Zionist Organization."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-51"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" The largest minority in interwar Poland were the Ukrainians, and irredentist groups within that population of more than five million waged a violent campaign marked by high-profile assassinations against the Polish government."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-52"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" The “Ukrainian question” often trumped Poland’s “Jewish question.” Other minority groups, Germans, Belarusians, and those who described themselves as simply being from “here” ("), _c('i', [_vm._v("tutejsi")]), _vm._v(") meant that debates about minority rights extended far beyond Jewish circles."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-53"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" As usual, lived reality proved messy.")]), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "fig_1.1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f025-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_vm._v("Fig. 1.1. An archway in the Jewish quarter of interwar Warsaw.")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Photo collection of Willem Van de Poll/Nationaal Archief of the Netherlands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("The Jewish population, like all populations in Poland, had experienced the effects of a massive depression in the 1920s and 1930s, which left 40 percent of the working population idle, reduced industrial production by 35 percent, halved wholesale prices, and substantially reduced fiscal revenue and foreign trade."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-54"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Unlike other populations in Poland, they encountered discrimination and antisemitism in their daily lives, from severe limitations imposed by antishehita laws and government officials calling for the emigration of “excess” Jews to the pervasive “ghetto benches” cordoned off for Jews at universities and the “Aryan paragraphs” that constricted membership in all different types of professional organizations."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-55"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" The generation born in the wake of the Great War and their ancestors may have had relatives who had moved abroad, to the United States, South America, western Europe, or Palestine. And while the financially solvent “American cousin [remained] the last hope of every Eastern Jewish family,” some of those relatives eventually came back."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-56"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" For a majority of Jews in Poland, their "), _c('i', [_vm._v("doykayt")]), _vm._v(", their sense of “here-ness,” their rootedness, was practical, territorial, and temporal."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-57"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" As much as Polish Jews could anticipate the route their life would take, a continued existence in Poland seemed well within the range of immediate possibilities. It was the only reasonable possibility for most.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOW ARIEH TARTAKOWER AND JAMES MCDONALD BALANCED THE REALITY OF ROOTEDNESS WITH CALLS FOR MIGRATION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some activists attentive to the rootedness of east central European Jews advocated for small-scale and organized migrations that would benefit both the Jews who left and those who stayed behind. The next section highlights two such voices, one from the Polish Jewish WJC activist and wartime “Office Committee member” Arieh Tartakower and the other from James McDonald, an American who served as the first high commissioner for refugees (Jewish and others) from Germany beginning in 1933 when the office was created until his resignation at the end of 1935. Both Tartakower and McDonald had unique vantage points on the tension between Jewish rootedness and political developments in east central Europe that attempted to cast Jews as nonindigenous “others.” Because of their vastly different kinds of expertise, they would have "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("different reasons for supporting controlled Jewish migration away from Europe, yet both conceded what this chapter has already suggested: while some emigration was possible, the future homes for most east central European Jews would remain in Europe.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arieh Tartakower intimately knew about rootedness and the difficulties inherent in migration. Trained as a lawyer as well as a sociologist, by the late 1930s Tartakower had become a noted expert on Polish Jews and their migrations. He also knew that emigration did not always succeed. After serving in the Austrian army during the Great War, Tartakower finished his doctorate at the University of Vienna and settled in Łódź after a bout with malaria cut short a stay in Palestine."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-58"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" There he began building a solid academic and political profile, serving in the city council and acting as chair of the Histadrut (a Zionist labor party)."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-59"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" In 1925, he and his wife, Malwina, welcomed their first and only son, Jochanan. Besides this work, he lectured at the Instytut Nauk Judaistycznych in Warsaw and published on demography, the structure of societies, and the complexities of migration across four languages."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-60"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" His two-volume compilation "), _c('i', [_vm._v("The Jews in Renewed Poland: Activities, Society, Economy, Education and Culture")]), _vm._v(" remains one of if not “the best synthesis of Polish Jewish History.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-61"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" He also was a delegate to the World Jewish Congress in 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When during its second session on August 9, 1936, he spoke on “Emigration and the Politics of Jewish Emigration,” Tartakower joined a pressing conversation to which he was already closely connected. Unlike Joseph Roth, who in 1937 could not summon “the grace and insight to suggest some way out of our present difficulties,” Tartakower offered a solution: the World Jewish Congress would help manage emigration out of Europe to better preserve Jewish life in Europe."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-62"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Quoting numbers that drew from his own research, Tartakower told the audience that before the war, 150,000 Jews had emigrated from the Polish lands annually, yet now that number had declined by two-thirds, flowing mainly to Palestine in part due to restrictive American policies."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-63"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" He recommended that the WJC develop publicity encouraging Jews to leave Europe, negotiate with governments to find emigration possibilities, and help Jews transfer assets, all in order to reduce a “surplus” of Jews and ameliorate economic consequences. A solution to the “question” of emigration would take many years but would unlock opportunities, securing “the possibility of a new and decent life for hundreds of thousands.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-64"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Instead of unlikely mass transfers of rooted populations, Tartakower and his colleague Jacob Lestschinsky spoke of controlled emigratory flows to alleviate overpopulation. They were not alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James McDonald, former chair of the Foreign Press Association, became high commissioner for refugees when Germany withdrew from the League of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("Nations in 1933. His office was affiliated with (but not financially supported by) the League of Nations and included delegates from a handful of League member states, such as Poland, Czechoslovakia, the Netherlands, and Argentina."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-65"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" To investigate the refugee issues plaguing Germany and east central Europe, McDonald traveled to the region in spring 1934 and embarked on a multi-city tour. While in Warsaw and other Polish towns, McDonald outlined a plan to assist the “thousands of German refugees scattered all over Europe” who became stateless and often lacked access to a valid passport once they left Germany and their former state canceled their citizenship. He offered surprisingly concrete details of this plan in an interview given to Polish Jewish journalist Joel Cang, who himself is the subject of the last section in this chapter.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Complicated problems demanded multiple solutions, and McDonald prioritized them for Cang and his readership. First, all refugees should acquire passports and temporary permits. Second, he wanted to ensure that the sixty-five thousand German refugees, 80 percent of whom were Jewish, would find work. Most were in France, but there were also significant populations in Belgium and the Netherlands and upward of six thousand in Poland. Third, McDonald envisioned the thrust of his work to involve “the settlement of as many as possible of the Jewish refugees in Palestine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-66"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" During the previous year (1933–1934), ten thousand German Jews had arrived in Palestine, and he expected nearly as many “to be settled there in the course of the next twelve months.” With the help of donations from British and American Jews, “resettlement” should commence in “countries overseas whose governments have expressed willingness to admit a considerable number of skilled and professional refugees.” His office could entreat governments about emigration outlets and could facilitate the transfer of property and assets held by evacuating Jews."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-67"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Recently, McDonald had proposed a loan of several million pounds to help the refugees at the League of Nations; this proposal drew inspiration from a similar loan “floated under the auspices of the League to help Greece resettle her nationals a few years ago.” Cang reiterated McDonald’s view at the end of his article. The main center for resettlement “must be Palestine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-68"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like Arieh Tartakower speaking in Geneva two years later, James McDonald advocated a transnational institution to coordinate emigration activities (his office, not the WJC), planning for economic consequences, and making Palestine a viable destination for Jews. He differed from Tartakower in other registers, the first being scale. McDonald wanted as many Jewish refugees as possible to settle as quickly as possible in Palestine. To justify his plan, he cited the Greco-Turkish population exchange (interestingly, not in terms of the transfer of two populations, which it was, but as a resettlement of one ethno-religious "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("group) in connection to his plan to have wealthy Jews in America and Britain subsidize the movement of German Jewish refugees away from Europe. Tartakower did not employ this example at this time. As "), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 2")]), _vm._v(" shows, McDonald was in the minority. Diplomats, statesmen, and actors connected to the League of Nations rarely envisioned mass population transfers as an acceptable tool available to states or international organizations.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McDonald prioritized the Greek-Turkish case because it was a League-endorsed endeavor that he hoped could serve as a precedent. But his brief invocation ignored the reality that this event—the forced movement of 1.6 million people—was a “human catastrophe of hitherto unknown dimension” that unfolded amid brutality emerging out of the Greek-Turkish War."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-69"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" McDonald did not, it should be noted, make reference to the treaty signed between Turkey and Bulgaria in Adrianopole in 1913, which was the first interstate treaty on the exchange of populations in modern history."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-70"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" In the wake of the peace treaties that concluded the Great War, European states became, for the most part, imbricated in a system based on minority rights, not a system based on the rights of states to manage their minorities."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-71"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" The international community, bulwarked by the League of Nations, did not sanction mass population transfers or mass expulsions."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-72"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" In fact, the League of Nations was built, as McDonald himself argued convincingly elsewhere, on nearly three centuries of precedents protecting the rights of minorities to be rooted and protected within states."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-73"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" Here McDonald was citing an extreme exception as he built a logistically untenable argument.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, the situation facing McDonald and his commission was new and urgent but not necessarily unprecedented. On February 20, 1921, the International Red Cross approached the Council of the League of Nations with a request concerning the hundreds of thousands of Russian refugees who had, since the beginning of the Great War and the two Russian Revolutions, flooded into border countries and had lost Russian citizenship on Lenin’s initiative in 1921. To ameliorate the situation, the International Red Cross Committee “proposed that the League should appoint a High Commissioner for Russian Refugees” to consider three main aspects: first, “the definition of the legal status of refugees; second, their repatriation to Russia, their emigration to other countries, or the organization of their employment in the countries where they were residing; and third, the co-ordination of the various efforts already being undertaken for the material relief of the refugees.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-74"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" The council agreed to appoint a high commissioner with the understanding that the League was not responsible for the “organization or financing of relief and that its work should be considered temporary.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-75"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("On September 1, 1921, Dr. Fritdjof Nansen assumed the office of the high commissioner for Russian refugees, and by July 1922, Nansen had convened an Intergovernmental Conference that “accepted an arrangement for a certificate of identity which would be considered valid by adherent countries.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-76"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" This certificate became known as a “Nansen passport.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-77"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" In practice, citizens deprived of citizenship from their former state could, in exile, apply for a Nansen passport and thus have some semblance of official identity papers, travel privileges, and domicile status for a finite period."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-78"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" Alongside his work creating, maintaining, and extending his namesake passport, Nansen helped in the evacuation of 156,000 Greek refugees from Asia Minor and of 10,000 Turkish refugees to Asia Minor. His work paved the way for the consequent movement of 650,000 Greek refugees, the movement of more than 125,000 Bulgarian refugees that had to be settled within Bulgaria, and the settlement of Armenians in Erivan. Nansen also “made himself the spokesman for the claims of the Ruthenians, the Montenegrins, refugees from Central Europe and Jewish refugees in Rumania ["), _c('i', [_vm._v("sic")]), _vm._v("]” before his unexpected death in 1930."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-79"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While McDonald could trace a lineage from Nansen’s commission to his own, McDonald’s interview with Cang as well as his extensive diary reveal an initiative quite different from the activity associated with Nansen’s name. In part because of his friendships and financial partnerships with American Jewish groups and individuals such as Felix Warburg as well as contacts with politically influential Jews such as Chaim Weizmann, McDonald frequently pinpointed Palestine (and not, notably, America) as an ideal location for German Jewish refugees and suggested that wealthy Jews elsewhere should activate their bonds of solidarity through monetary donations or investments to ensure the passage of these refugees from their former countries to the Palestinian Mandate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tartakower also drew on refugee-related trajectories after the Great War to justify the role he proposed for the WJC in the mid-1930s, but his plans seemed much less ambitious than the ones offered by McDonald. The same year he spoke at the first meeting of the WJC in Geneva, Tartakower detailed how the WJC should respond to the contemporary emigration situation in a Yiddish-language brochure published in Paris. Across fifty pages, Tartakower described how “bitter and serious times” initiated after the Great War had narrowed the options for “hundreds of thousands who need to emigrate in order to save themselves from physical and spiritual destruction.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-80"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" Organizations dedicated to helping Jewish immigrants had failed to offer “a certain idealism of national enthusiasm, which can only be achieved if the colonizing work is carried out by the organized people and not by separate institutions.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-81"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Ideally, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("when the WJC became a permanent institution (and it was more or less permanent by the end of 1936), Tartakower proposed, its executive branch should include an emigration department. This department would “function as the highest controlling body of all Jewish emigration associations: coordinating their activities, as well as their activities with those of other Jewish economic, and possibly also political, institutions, and issue certain orders.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-82"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Diplomatically, this department would have far-ranging influence, negotiating with “states and international corporations: and creating central institutions” like a “Jewish Emigration bank” and a “Jewish colonization fund.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-83"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" Tartakower did not expect the WJC to eclipse existing emigration organizations. Rather, he thought the WJC could become an umbrella organization coordinating and improving their work. Finally, in terms of public opinion, the WJC had the capacity to lead an “awareness-raising campaign” and educate the Jewish masses about the interconnectedness of emigration and socioeconomic realities."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-84"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tartakower knew that the population of Poland was growing, and the elimination of emigration options, mainly to the United States and western Europe, meant that more people suffered in deteriorating economic conditions. In Tartakower’s assessment, the natural growth of nearly thirty thousand Polish Jews annually increased “social pressure” and “pauperization.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-85"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" According to his numbers, the non-Jewish population by the 1930s was growing naturally at double the rate of the Jewish population, and Jewish demographics were thus being diluted overall."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-86"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" For Tartakower, this status quo was untenable. Higher populations strained an already struggling economic and social atmosphere. Besides this, he expressed concern for the “spiritual and moral decline” of Polish Jews as a whole and a lack of organized emigration options that could alleviate the population’s strain on the faltering economy."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-87"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Grouping Polish Jews by size of settlement, Tartakower noted that in big cities the assimilation of the Jewish population had quickened, the marriage age for Jews had increased well beyond the norm for non-Jews, and the percentage of children born outside of marriage had drastically increased, sometimes at a rate more than three times higher than that of the non-Jewish population.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elsewhere in his writings, Tartakower outlined his concern for the Jews as a people even more explicitly. In his 1938 publication "), _c('i', [_vm._v("Zarys socjologii żydostwa")]), _vm._v(" ("), _c('i', [_vm._v("Outline of Jewish Sociology")]), _vm._v("), Tartakower considered the future of Polish Jewry from several angles, offering a vigorous and nuanced definition of Zionism that included an awareness of Arab populations and providing for settlement outside of Palestine as well as continued support for the continuation of diaspora life. He conceded that “only the creation of its own normal national existence may respond to the tragedies of Jewry ["), _c('i', [_vm._v("tragedie żydostwa")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-88"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" But accepting "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("this fact did not preclude a future for Jews living in the countries of the "), _c('i', [_vm._v("goles")]), _vm._v(" or the reality of “Zionists” fighting for the future of this diaspora."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-89"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" And while the creation of a Jewish state “would undoubtedly correspond to the will of the overwhelming majority of Jewish society on the whole globe,” other forms of territorialism and colonialism should not necessarily be eliminated from short-term (this is undefined) plans. “Whether and in what form the proposed Jewish state will be implemented is,” Tartakower admitted, “difficult to predict in the present transitional period.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-90"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" Despite his ideological views on the need for separate national space, Tartakower remained a realist. Like others of his era, his view of Palestine-centric Zionism had an elastic quality, and his understanding of Polish Jewish rootedness was nuanced."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-91"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McDonald saw the Jewish and Polish Jewish worlds in much starker colors. An article filed by Joel Cang in the "), _c('i', [_vm._v("Jewish Chronicle")]), _vm._v(" after McDonald’s visit to Warsaw in 1934 revealed that the high commissioner had even more ambitious albeit vague plans for the Jews of Europe. McDonald wanted to consider not only “refugee” problems but “the Jewish problem as a whole.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-92"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Perhaps this urge led McDonald to have a “long conference” with Jabotinsky in Warsaw, where the “revisionist leader outlined his views on the possibility of settling an increasing number of Jews in Palestine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-93"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" McDonald did more than meet with Jabotinsky; he danced with him as well. The two spent an evening of food and music at the Adria restaurant, and McDonald was so intrigued by Jabotinsky, who “interrupted the dancing with brilliant and pungent phrases which bit like acid” about Weizmann and others opposed to the Revisionist cause, that he invited him for a luncheon the next day. His two talks with Jabotinsky “deeply impressed” him on several registers. McDonald’s remarks about larger Jewish problems, however, were not solely related to his conversations with the Revisionist leader. Across three days in Warsaw in April 1934, McDonald encountered Jabotinsky twice, convened with a twenty-one-member committee “representing every faction and shade of Jewish opinion in Poland,” and had tea at Dr. Mojżesz Schorr’s house. It is possible, however, that McDonald’s words to Cang were inspired by a day of traveling in and beyond Warsaw.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout his eight-hundred-page diary covering the years 1933–1935, McDonald noted hundreds of memorable conversations and exceptional trips across Europe and the Americas. The day he spent traversing the Jewish quarter of Warsaw and two villages outside of town offered “impressions” that would “never be forgotten.” Two things stood out: people’s extreme poverty and their infatuation with Palestine. In Warsaw, the travelers entered “two hovels where whole families lived” in “wretched clothes and shoes that were eloquent proof of the wretchedness of the people.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-94"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" In a larger unnamed village, McDonald "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("and his entourage went to the market, the headquarters of the halutz, and the cooperative bank and en route got caught in a thick crowd of people alerted to his presence."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-95"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" “How piteously,” McDonald observed after just a few hours in these places, “the people look to Palestine! It is for them the solace now and the hope for the future. I can now begin to understand the powerful populist appeal which Weizmann, Jabotinsky and other Zionist leaders no matter how much they may differ as to methods make to the masses of the Polish and eastern Jews.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-96"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" McDonald was struck by the perceived fractures cutting through Polish Jewish society. And it was obvious that the combined effects of time spent with Jabotinsky and an encounter with longings for Palestine in Poland’s countryside had left deep impressions on a man already interested in linking the German Jewish refugees with emigration opportunities in Mandate Palestine. And yet, even if McDonald harbored his own Zionist visions of finding opportunities in Palestine for Poland’s Jews, he provided no more specifics at this point than either Jabotinsky or even Weizmann.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Five days after McDonald’s three-day trip to Poland, on April 25, 1934, Barent Litvinof of the "), _c('i', [_vm._v("Jewish Chronicle")]), _vm._v(" asked for clarification about McDonald’s supposed claim that it was insufficient to simply consider the refugee problem; “one must consider the question of Jewish emigration as a whole.” McDonald replied that he had “nothing more to say.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-97"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" Throughout his appointment as high commissioner from the fall of 1933 to the end of 1935, McDonald did not reveal many specifics about the options his committee considered. His copious diary says nothing about his involvement in the Haavara agreement, although he did lobby the British to have Jews enter Palestine."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-98"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" He spoke with colleagues about the foundation or expansion of Jewish settlements in Biro-Bidjan, Portuguese East Africa, French colonies, the United States, and South America. McDonald spent a dozen weeks in South America in 1935 but did not commit to facilitating large-scale German Jewish emigration."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-99"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" On October 8, 1934, Weizmann refused to embark on a joint effort with McDonald’s committee because he didn’t want to be “married to a corpse” (McDonald had refused to travel to Palestine ahead of his trip to Brazil and Argentina). McDonald recognized that a diverse collection of Zionists, non-Zionists, and anti-Zionists held positions of power in British and American Jewish organizations and would not endorse a worldwide response to a problem they deemed associated only with displaced German Jews."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-100"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tartakower’s vision had a broader scope, which involved more synthesis among actors and the marginal reduction of the diaspora. His writings and activities, however, hinged on an undeniable reality: even if the WJC could create new emigration outlets, millions of Jews would remain in Poland."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-101"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" And "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("this reality, the reality of the rootedness of Jews in Poland, was, in Tartakower’s words, “uncheerful, often tragic but not necessarily hopeless.” Reflecting on Jewish life in Poland near the end of 1938, just months after Poland’s government revoked the citizenship of Polish citizens who had lived abroad continuously for more than five years, Tartakower described the moment as one when “it is difficult to play with prophecies because we do not know what the next day will bring.” He remained conditionally, perhaps hesitantly, optimistic despite this. “But, if in the end,” he wrote, “the nightmare of the current political and social relations passes” and “the Polish state overcomes the current economical issues and subjugates the hydra of anti-semitism, which is the threat not only to the Jews, but also undermines the foundations of the whole society, then better times will come also for the Jewish people.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-102"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("McDonald was less optimistic about the situation in Germany. A few months before resigning his position in December 1935, he wrote to Eleanor Roosevelt (and by way of her, the president) about the enormity of a situation that few seemed to grasp. “Unless present tendencies are sharply reversed,” McDonald insisted, “the world will be faced in the near future with the problem of another great exodus of refugees from Germany.” Furthermore, this man who had met Hitler in April 1933 believed that Reich leaders had “set for themselves a program of forcing gradually the Jews from Germany by creating conditions there which make life unbearable.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-103"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" He had spent more than two years advocating for the stateless German Jews in neighboring countries and for the Jews of other nationalities who had been expelled from Germany and who either had been forced back to their former states or lived, like hundreds of Polish Jews in Antwerp, in circumstances of precarious legality."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-104"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" Over time, McDonald had become frustrated with his lack of authority, the informal relationship his commission had with the League of Nations, and the lack of empathy shown by the so-called Christian world. Moreover, he had learned that it was difficult even for the German Jews and Jews of other nationalities within Germany who had been forcibly expelled to find new homes when few destinations were available to them in the 1930s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And despite assertions from luminaries such as Louis Brandeis that Palestine could absorb between four and five million emigrants, or Chaim Weizmann that five hundred thousand Jews (not necessarily from Germany) could settle in Palestine before he died, McDonald could not unite enough powerbrokers from Jewish and British circles behind his hope to make Palestine the main center of resettlement."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-105"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" Nonetheless, he did help make Palestine a favored destination among German Jews during and after his time as high commissioner. Interestingly, a "), _c('i', [_vm._v("New York Times")]), _vm._v(" article announcing the appointment of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("McDonald’s replacement, Sir Neill Malcolm, noted that future refugee work would benefit from a plan to expatriate one hundred thousand Jews from Germany over four years and settle half of them in Palestine."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-106"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" Malcolm would travel to Geneva and address the first meeting of the World Jewish Congress five months into his term.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There, the optimism and declarations of unity infusing Tartakower’s writings rang out frequently. Stephen Wise and Nahum Goldmann considered the meeting a turning point in Jewish life as the end of an era of “Jewish division and unconcerted action.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-107"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" In a strange way, declarations from Tartakower, Reiss, Wise, and Goldmann as well as other Jewish observers of the late 1930s sometimes mimicked the demands of interwar historians of the European Jewish experience who expected solidarity when, for the most part, disunity reigned."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-108"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Disagreement riddled the conversations of WJC delegates. Berl Locker, for instance, who had journeyed to the meeting from Palestine, claimed that his peers in the Polish delegation were not elected democratically and represented certain political parties instead of a unified Polish Jewry."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-109"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" American Louis Segal applied the same criticism to the US delegation, which did not include any representatives from the “Jewish plutocracy” or the “Jewish labor movement.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-110"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" Moreover, several delegates expressed anxiety about how delegates to the WJC were selected in their own home countries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The disharmony reached a pitch when the deliberations devolved into an argument over the preamble to the WJC constitution. On behalf of the so-called Executive Committee, Dr. Jacob Hellmann from Poland proposed that the wording “The World Jewish Congress is the representative body of the Jewish collectivity in matters relating to Jewish life in the diaspora” should be accepted by all constituents, thus provoking heated debate. More than ten years later, Aryeh Leon Kubowitzki recalled that “the American, English, Italian and Swiss delegations oppose[d] the wording because it [was] not a statement of fact, since it declare[d] the WJC to be the representative body which in their opinion it can only aspire to become.” This objection stalled the adoption of the WJC preamble at the 1936 meeting, instead punting the issue back to “the executive with the understanding that the reference to the representative in charge of the congress is a goal to be reached rather than as a statement of fact.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-111"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" Perhaps ironically, the delegates found it difficult to agree on the democratic process of delegate election and their constitution’s preamble. In this way, the fundamental issues confronted at the first WJC meeting in 1936 reveal massive disunity despite calls for and promises of the opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And yet, in spite of these impossible calls for unity and the harsh reality of disunity, a seemingly unified set of problems facing east and central European Jewry remained: the unexpected emigrations unleashed by the political rise of Adolf Hitler and his Nazi Party, the status of these now-stateless uncitizens, and the broader issue of minority rights throughout east central Europe. In Poland, Jews together faced “ghetto benches” and other forms of discrimination at universities, bans against the ritual slaughter of animals (shechita), and boycotts throughout the country that contributed to the further economic demoralization of Jews in Poland."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-112"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" These remained key issues precisely because these Jewish populations were rooted (for better, for worse, and for the future) in east central Europe. Experts such as Tartakower provided statistical data, but to a certain extent the dire state of Polish Jewry became increasingly obvious to novice eyes despite further attempts by the Polish government to encourage emigration, often with charged antisemitic language. On Józef Beck’s instructions, for example, the Polish delegate to the Economic Commission of the League of Nations “raised the question of Jewish emigration on 5 October 1936, claiming that the Jewish problem in Poland required rapid measures of relief.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-113"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Moreover, as Polish government officials continued to cultivate contacts with international Zionist organizations, a group of Polish government experts went to Paris in May 1937 to again discuss with the French opportunities for Jewish settlement in Madagascar. Even further, in 1938 a non-Zionist Jewish committee for colonization headed by Mojżesz Schorr (who had himself attended a meeting of the 1905 World Zionist Organization) was set up under ministerial patronage “to foster emigration to countries other than Palestine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-114"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" Despite these efforts, barely nine thousand Jews left Poland in 1937."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-115"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" And so, it was in the interest of officials from the World Jewish Congress to organize Polish Jewry more systematically.")]), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "fig_1.2"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f036-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption0"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("Fig. 1.2. Muranowska Street in the heart of the Jewish quarter of interwar Warsaw.")])]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Courtesy YIVO Digital Archive on Jewish Life in Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BARUCH ZUCKERMAN AND THE WJC")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S FAILED MISSION TO POLAND, 1937–1938")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Only a Talmudist could possibly understand Polish Jewish politics,” Nahum Sokolov lamented on his visit to Poland in 1933. While not a Talmudist himself, Baruch Zuckerman had developed an understanding of Polish Jewish politics after nearly a year in Poland. He learned that the language he used to discuss Jewish politics in the United States often proved redundant in Poland. By appointing Zuckerman to travel to Poland and compel Polish Jews to purchase ballots, cast votes, and create a national congress, which could become an affiliate member of the World Jewish Congress, executive members of the WJC hoped to diminish a paradox that was evident at the 1936 inaugural meeting of the WJC in Geneva: the unrepresentative nature of the World Jewish Congress delegation. To be more effective and have more international legitimacy, the WJC needed documented constituents, and where better to find them than in Poland, home of the largest Jewish population in Europe and the second largest in the world after the United States?"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-116"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The WJC’s plan to convene a Congress of Polish Jews ultimately failed, but this failure is illuminating on at least three registers."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-117"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" First, an exploration of Baruch Zuckerman’s assignment to organize Polish Jewry into a constituent body of the larger World Jewish Congress helps us understand contemporary political descriptors in a more nuanced way. Zuckerman’s report shows that the adjective "), _c('i', [_vm._v("Zionist")]), _vm._v(" had acquired a specific meaning in the Polish context by the late 1930s, and there were, in fact, a “bewildering number of Zionisms.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-118"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" In 1939, by way of example, the World Zionist Organization counted three separate Zionist federations, each of which corresponded to past partitions of Poland and each of which was dedicated to improving daily lives of Jews in Polish spaces."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-119"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" Second, Zuckerman’s failure confirms how elusive “unity” was among Polish Jews at this time. Even when attempting to unite Jews around a supposedly “neutral” platform, Zuckerman and his colleagues spread out across the country found it impossible to synchronize this “hopelessly divided” "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("community."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-120"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" Third, and perhaps most importantly, the failure of Zuckerman’s mission in 1937–1938 demonstrates the limits of the World Jewish Congress’s power and authority, especially vis-à-vis Polish Jews. The World Jewish Congress had little mandate to speak or act on behalf of a population that refused to organize on the WJC’s terms in the late 1930s.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In February 1938, slightly less than a year after his arrival in Poland, Zuckerman offered a report that detailed both his work rallying support for the WJC and the Congress of Polish Jews (later called the Congress of Jewish Self-Help in Poland) and his opinions about the reality of the present and plans for the future."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-121"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" Even after eleven months in the country, Zuckerman remained shocked by what he observed. “The mutual hatred among Jewish parties in Poland,” Zuckerman wrote, “and the mottos employed in their fights among each other are often simply unbelievable.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-122"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" Even “in the face of the greatest catastrophes that have occurred recently,” he continued, “it was impossible to organize a common defense front.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-123"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" Entrusted by the WJC with “helping Polish Jewry to organize itself,” he had spent months with its leaders, digested myriad newspapers, traveled across the country popularizing the WJC to Polish Jews, and sold voting cards to those interested in helping create a Polish Jewish Congress. His report shows that Polish Jewry in 1938 defied simple categorization. Zuckerman’s reference point of American Jewish politics had proved a faulty prism through which to view the complexity of Polish Jewish experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a country of more than three million Jews, Zuckerman estimated nearly as many different outlooks. He admitted, for instance, that “almost every thinking Jew has his own program and his own way of achieving the balance” of galuth."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-124"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Even familiar words such as "), _c('i', [_vm._v("assimilationist")]), _vm._v(" and "), _c('i', [_vm._v("nationalist")]), _vm._v(" could not be understood axiomatically because the division between those “supposed” groups had “long since lost its exactitude.” To Zuckerman’s surprise, even the word "), _c('i', [_vm._v("Zionist")]), _vm._v(" had acquired a new meaning. “Very often now,” he admitted, “we meet Zionists of various shades who adopted the viewpoint that Jews are absolutely and eternally rooted in the soil of Poland.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-125"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" This had changed since the Great War. Before 1914, “Zionists spoke very openly and clearly about exile from the "), _c('i', [_vm._v("galuth")]), _vm._v(", now, however the situation is such that Zionists are afraid of such open talk.” Changes in the “last few decades, especially in Poland, forced them to emphasize Jewish integrity in Poland and to fight against the emigrationist attempts of the Polish Government.” The non-Zionists, Zuckerman explained, went even further and regarded “all talk about an emigration event to Palestine as a crime against the interest of the Jews of the Poland.” Despite both fighting for the continued existence of Jews in Poland, an “enormous abyss” existed between Zionists and non-Zionists, “the like of which [did] not "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("exist in any country in the world.” And perplexingly, Polish Jews would switch from “party to party according to the type of election and issue at stake.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-126"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" The political climate in Poland forced the recalibration of Zuckerman’s basic political vocabulary, and debates over emigration had reshuffled the loyalties and beliefs of Polish Jews substantially.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Conversations across political parties and economic divides often returned to the intertwined issues of emigration, the status of Palestine, and the future of Jews in Poland. After first convening with the twenty or so Polish Jews who already had an affiliation with the WJC, Zuckerman expanded his network."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-127"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" The Folkist (or People’s) Party, led by party leader and newspaper editor Noach Pryłucki, who had attended the inaugural meeting of the WJC in Geneva, initially joined conversations with Zuckerman but later withdrew after conflicts developed. The main difference between the People’s Parties and the Revisionists, Zuckerman noted, “was on the question of whether Palestine should find a place in the Congress or not.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-128"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" The Revisionists insisted that Polish Jews as a group issue a “resolution which would in the name of Polish Jews demand that England and the League of Nations remain true to their obligations.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-129"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" The People’s Party could not accept this idea, nor could they accept the organization taking a stand on the problem of emigration. Once disconnected from the congress, Pryłucki began, in Zuckerman’s evaluation, “an active campaign against the Congress.” As the Joint Distribution Committee (JDC) and certain ministries in the Polish government also worked to “sabotage” the activities of the WJC, Zuckerman found himself increasingly surrounded by vocal enemies and unable to rescue the work of the congress from the internal and external issues plaguing it."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-130"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zuckerman and the organizing committee of the Congress of Polish Jews strove to create a democratically elected body that represented all Jews, regardless of gender, political party, or religious affiliation, living in Poland."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-131"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" They failed partially because of the issues detailed in Zuckerman’s 1938 report and mostly because their call for unity proved decidedly divisive. Nearly all voices in the Jewish press wrote with the censors in mind, some mocked the initiative, and others supported the efforts of the organizing committee as the process to select a countrywide Polish Jewish representative body crescendoed between December 1937 and March 1938."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-132"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" On many occasions, organizers encountered aggressive resistance by state officials. Called at some moments the “Congress of Polish Jews” and at other moments the “Congress for Jewish Self-Help,” the discussions around the campaign lacked emphasis on specific goals besides the oversimplified promise to offer a representative voice for Polish Jews. Like the Provisional Jewish National Council before it, which attempted in 1919 to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("convene a National Assembly that would be elected democratically by all adult, male Jews in Poland, the imagined congress was never elected because of the organizers’ inability to resolve contested issues and simplify their initiative in a way that would interest multiple sectors of Polish Jews. Organizers and their helpers included men such as Moses Kleinbaum, Arieh Tartakower, Ignacy Schwarzbart, and Anselm Reiss."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-133"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The coverage of the event in the Polish Jewish press diverges from Zuckerman’s February 1938 report and shows the ways in which Zuckerman and his peers oversaw and facilitated a two-part process in 1937 and 1938 to bring the Congress of Polish Jews to fruition. First, delegates from across Poland bought voting cards with both Polish and Yiddish imprints to essentially register themselves as “democratic” members of the Polish Jewish masses."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-134"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" Second, the delegates on these registration lists would elect representatives to speak on behalf of Polish Jews in a body that would convene in the near future. The planning for countrywide registration of all Polish Jews picked up in the fall of 1937 when the Central Organizing Committee announced plans to convene eleven regional conferences in places such as Łódź, Wilno, Równo, and Białystok on November 10."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-135"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" To this end, all the offices of the Jewish Economic Committee, like the one in Łódź, would be transformed into offices for the Polish Jewish Congress in pursuit of a successful registration and later election."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-136"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" By November 18, "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v(" reported that the Central Organizing Committee had ordered 1.25 million voting cards for purchase, each representing an individual’s registration to vote for the congressional body. On the next day, Nahum Goldmann traveled to Łódź to give a speech on the initiative at WIZO. Another event in Łódź one month later failed to draw a large audience because authorities had restricted access to the planned meeting room. Two hundred delegates from fifty-two cities in the Łódź region moved to a room too small to accommodate everyone. Among the speakers at this event, Arieh Tartakower lamented that the largest Jewish communities in the Łódź region would not be represented at the conference."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-137"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite these hurdles set up by state authorities, the campaign continued and gained momentum."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-138"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" An advertisement in "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v(" on December 26, 1937, announced that one thousand volunteers would spend St. Stephen’s Day selling election cards for the newly renamed “Jewish Self-Help Congress in Poland.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-139"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" By the first week of January, there were organizing committees in more than five hundred towns, and the Central Organizing Committee had begun distributing questionnaires to assess the results of the election card campaign."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-140"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" In Kraków, under the leadership of Rabbi M. J. Klieger, a meeting on January 5 passed “unanimously a resolution in which nonpartisan religious "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("Jewry declared its accession to the Congress of Polish Jews.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-141"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" A few days later, on January 9, the Central Organizing Committee announced that district conferences in Białystok and the Wołyń region would take place and that representatives of the Jewish community and political parties would attend."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-142"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" The Warsaw committee was organized around the same time."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-143"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" By January 13, voting cards went on sale in Katowice."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-144"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" Mayors in a few cities in Volhynia such as Kostopol and Berezna confiscated voting cards in mid-January, thwarting some efforts to rally support for the congress."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-145"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" On January 16, representatives of the Organizing Committee held an event in Buczacz, while in Warsaw the congress opened, with nearly 250 different groups, organizations, and institutions participating."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-146"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" Initial reports delivered at this event were optimistic. Two hundred thousand election cards had been sold in the Małopolska region, along with three hundred thousand in former Congress Poland (or Lesser Poland). Soon, the Central Organizing Committee in Warsaw decided that five hundred delegates would be elected from across three historic regions."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-147"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As deadlines approached, a publicity campaign ran through the Jewish press. From late January through the first week of February, eight ads appeared in "), _c('i', [_vm._v("Chwila")]), _vm._v(", including one on January 30 promising that the “Congress would fight for a better tomorrow for the Jews.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-148"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" On January 30, a rally took place for academics devoted to the Jewish Congress in Poland. Dr. Moses Kleinbaum, Dr. Ch. Szoszkies, and lawyer Zorach Warhaftig, among others, helped stimulate interest in the initiative."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-149"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" Kleinbaum also addressed a crowd a week later, this time with Anselm Reiss, who had announced the declaration of the unified Polish Jewish delegation at the 1936 Congress in Geneva."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-150"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" In an editorial on February 3, Dr. Eliasz Markus drew an allusion between the congress and the Council of Four Lands, suggesting that Polish Jews had “remained broken down in individual groups, devoid of a common platform” and declaring that the time when one Jewish party played off another party to gain power had “passed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-151"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" This initiative, Markus declared, would produce a “dignified” and “serious” representation for the entire Jewish community. Still, people had to be reminded to get involved. A written appeal from the Central Organizing Committee of the Jewish Congress in Poland complemented two broad advertisements in "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v(" in the two days before the sale of electoral cards was scheduled to end on February 7, 1938."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-152"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" The sales of the cards, however, passed beyond this initial deadline because the election campaign continued and garnered both supporters and opponents. On February 11, thirty-two different parts of the Jewish Craftsmen Union in Łódź agreed to “massively” participate in the campaign."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-153"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" The Prezydium "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("Rady Naczelnej Kupiectwa Żydowskiego (Presidium of the General Council of Jewish Merchants) decided not to support the work of the Central Organizing Committee."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-154"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" But thousands of others did, particularly those in medium and large cities."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-155"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the election campaign closed on February 27, 1938, the Central Organizing Committee began “preparatory work for elections,” which they hoped to schedule for April 24."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-156"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" A short update a few weeks later noted that Central Organizing Committee reports indicated a change in the date of the electoral calendar in response to a delay in negotiations with parties that were outside of the congressional sphere."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-157"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" Despite all these preparations, after “exhaustive discussions” within the committee in early April, the decision was made to “postpone the congress indefinitely.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-158"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" After months of press coverage, the plan for the democratically elected and unified congress of Polish Jews or the Congress for Jewish Self-Help in Poland “passed away without a trace.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-159"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Opinion pages were not kind to the Organizing Committee. In November 1937, for example, famed editor and writer Hillel Zeitlin criticized the committee’s partisan nature. The founders who demanded a congress, Zeitlin wrote, “remain[ed] faithful to their old party habits” instead."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-160"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" In “proclaiming a general Jewish congress, they mean[t] the creation of a new Jewish nationalist council” where some “Zionist groups [would] be represented,” other parties would be represented, and “non-party Jews [would] not be represented.” Less representative than the Jewish representatives in the Sejm, this congress, Zeitlin concluded, would caricature Jewish representation and be recognized as authoritative by no one. Likewise, Jakob Apenszlak, editor at "), _c('i', [_vm._v("Nasz Przegląd")]), _vm._v(", harbored doubts about how representative the congress would be. Addressing fifty-two delegates of the General Zionist Party, Apenszlak criticized the electoral structure as designed by the organizing committee. The Polish state, Apenszlak asserted, was more representative than this congress."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-161"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" Though favoring a congress, Apenszlak disagreed with the methods by which its organizers strove toward democratic representation as well as their end goals. For Apenszlak, a self-help plan for Polish Jews should “normalize the life of the Jewish masses against various emigration theories.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-162"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" As indicated by Zuckerman’s report, Noach Pryłucki, who had attended the 1936 meeting in Geneva, became a vocal enemy of the congress not only because of the campaign’s failure to emphasize Palestine-related or emigration issues."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-163"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" Instead of being a congress of the Jewish people in Poland, this charade would be, in Pryłucki’s assessment, “a Congress of a few Zionist parties.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-164"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Concluding his eight-page report explaining the failure to hold a congress, Zuckerman returned to the issue of emigration, which by February 1938 had "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("become an even more important node of Poland’s Camp of National Unity platform. Citing a speech by Bronisław Wojciechowski during the Sejm’s budget commission, Zuckerman linked discussions about Polish Jews to emigration."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-165"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" In Wojciechowski’s evaluation, “the responsibility of the Jewish problem in Poland does not rest with Poland but is international and . . . all nations must come together and find a solution to this problem.” This solution “will come in the way of emigration.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-166"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" And yet, Zuckerman feared that a disintegrated Polish Jewry would be ruined “more easily by this process of (economical and literal) uprooting.” He hoped, however, that “an integrated Jewry would still be able to make a stand. We are still three million people in Poland and still 10% of the population. It will not be easy to uproot the 10% if they are organized.” He envisioned the fate of Polish Jewry as wrapped up with the fate of world Jewry. In his concluding paragraphs, Zuckerman reflected on the WJC’s failing effort to organize Polish Jewry. “Polish Jewry,” he wrote, “spawned American and Palestinian migration” and “still is [a] rich and tremendous creative force. It represents a reservoir of cultural creativeness of the Jew for the entire world.” In fact, “a normal healthy Polish Jewry is a national treasure of first magnitude.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-167"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two important tensions run through Zuckerman’s report. First, questions about emigration infused discussions about Polish Jewry, and yet Poland’s Jews remained rooted in Poland. And second, even though the population of more than three million Jews was fragmented by gendered, generational, religious, political, social, linguistic, and economic cleavages, there remained a tendency to expect a semblance of unity, especially in the face of a palpable danger. While Zuckerman’s report remains a problematic source insofar as it is skewed toward explaining why his efforts to mobilize Polish Jews failed, his observations help us problematize foundational questions that cut through histories about the Polish Jewish experience during the interwar period and understand the political vocabulary of the 1930s.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOEL CANG")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S JOURNALISTIC EFFORTS TO CONTEXTUALIZE ROOTEDNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Baruch Zuckerman filed his eight-page report at the end of February 1938, Joel Cang was also in Poland, the country of his citizenship, working on an article that would eventually be published in the second issue of "), _c('i', [_vm._v("Jewish Social Studies")]), _vm._v(" in 1939. We now turn to Cang’s sociological research as well as his journalism to understand the rootedness of Polish Jews from two broader perspectives. First, as a Polish citizen writing for English-language audiences of the "), _c('i', [_vm._v("Guardian")]), _vm._v(", the "), _c('i', [_vm._v("News Chronicle")]), _vm._v(", and the "), _c('i', [_vm._v("Jewish Chronicle")]), _vm._v(" as well as scholarly "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("journals, Cang related Jewish issues to minority questions in general and Polish state policies on the Ukrainian minority (the largest minority in the Second Republic) in particular."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-168"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" Second, Cang relied on interviews he conducted with peasants and other “ordinary” Polish citizens. His writings reveal the rootedness of Jews as well as their Ukrainian, Belarusian, and Catholic neighbors, while showing once more why wide-scale plans for Jewish emigration failed. This perennial failure occurred as Hitler’s government increased its legal, ideological, economic, cultural, and social assaults on Jews in Germany and, in late 1938, expelled thousands of Jews of Polish heritage from the growing Reich.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his writings, Cang reveals programs advocating Jewish emigration as doubtful in reality yet potent as propaganda. Combining his expertise as a journalist with keen academic insight, Cang offered readers of "), _c('i', [_vm._v("Jewish Social Studies")]), _vm._v(" a nuanced look at the opposition parties in Poland and their views on the Jews’ predicament more generally. As he surveyed the complicated political landscape of post-Piłsudski Poland, he covered parties known for their antisemitism, such as Roman Dmowski’s National Democrats, the Conservative Party led by Prince Janusz Radziwiłł, and new parties including Mieczysław Michałowicz’s Democratic Party and the Stronnictwo or “faction” of Ignacy Paderewski, along with the Socialists, the Peasant Party, and youth movements suspended in between. His message was clear: demands for the emigration of Poland’s Jews had failed to capture political support from the Polish peasantry and had distracted Polish public opinion from real problems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Drawing on published speeches, coverage in a variety of party-specific and more generalized papers, and his own reading of human psychology, Cang worked through analyses of antisemitism and proposals for mass emigration. There were three basic approaches. The National Democrats (or Endeks) and the Conservatives consistently demanded that Jews leave Poland, yet by doing so they diverted attention from the real problems plaguing Polish society. Peasant parties had exhibited more moderate views toward the Jewish minority. Finally, the Socialists, despite some antisemitic outliers, remained committed to an inclusive Poland that included Jewish citizens en masse. While conversations about Jewish issues dominated domestic and international coverage related to the Second Republic, land reform and conflicts emanating from the Ukrainian and German minorities were, in Cang’s opinion, the largest problems facing the state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cang explained why, focusing on the suddenly caustic rhetoric of the Conservative Party vis-à-vis the Jews. At the birth of the Polish state in the early 1920s, 44 percent of the total land was in the hands of rich landowners, while sixteen million peasants, or 64 percent of the population, owned only about "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("10 percent of the arable land. Since then, “about three million hectares [were] divided out amongst the land-hungry peasants,” but “three million Polish farmers [were] forced to maintain themselves and their families on less than two hectares of land.” Polish nobles, Cang argues, staved off agrarian reforms that took place in other neighboring countries, and instead of making land available, they advised peasants to “‘go to the town’ and oust the Jews.” And so the “desire to retain their vast holdings” in fact “determined the anti-semitic policy of the conservatives in Poland.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-169"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much as antisemitic language could divert attention from discussions of land reform, so could an inordinate emphasis on the Jewish minority disguise problems of integrating the German and, even more so, the Ukrainian minorities."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-170"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" Throughout the 1920s and the 1930s, the government-sponsored newspaper "), _c('i', [_vm._v("Gazeta Polska")]), _vm._v(" detailed the deadly conflict that raged between “radical” Ukrainian nationalists and the Polish state. Writing elsewhere on the results of the state’s pacification policy toward Ukrainian populations in Poland’s east, Cang admitted that even though the “Polish Government ha[d] shown an honest desire to bring about some form of cooperation with some leaders of the Ukrainian minority,” after three years of normalization “Polish Ukrainian relations ha[d] reached a bad stage.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-171"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" And yet, despite the campaign waged by some Ukrainian radicals against the Polish state (which resulted in the assassinations of high-ranking government officials), a massive pacification campaign led by the Polish army against Ukrainian-dominated villages, and, later, official documents filed on behalf of Poland’s German minority before the highest international body, "), _c('i', [_vm._v("Gazeta Polska")]), _vm._v("’s journalists did not recommend compulsory evacuation or the forced migration of these decidedly more “problematic” minorities. The next chapter details how the idea of population transfers as a statecraft tool became more normative as the international community departed from an interwar system that supported, at least on paper, minority rights."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-172"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When and why do ideas casting Jews as belonging elsewhere coalesce and become public?"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-173"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" It is helpful to consider the shifts within the Peasant Party and Cang’s assessment of them to better understand how calls for Jewish emigration became popular at certain moments and served political ends."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-174"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" In December 1935, for example, the Peasant Party issued a platform at the United Peasant Parties Conference that included something new: a call for Jewish emigration from Poland to Palestine and other places."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-175"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" Yet this idea did not remain official policy for long. Soon afterward, the Peasant Party leader took down “the Jewish question from their time tables,” deciding to either “ignore the problem altogether or make but slight reference to it.” The individual peasant, Cang believed, had played a role in the elimination of this language. By "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("1937, the Jewish question was “not the most important problem in the country” for the Peasant Party."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-176"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" The problem of democracy proved more urgent. Cang cited the August 1937 peasant strikes and riots as further proof of the Peasant Party’s attitude toward the Jews. At a time when more than forty people were killed as a result of peasant violence, the Jewish population remained safe."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-177"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" And yet despite this, Cang admitted that the “Polish Peasant Party does not conceal its view that if someone must emigrate to Madagascar it should be the Jew and not the Polish peasant.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-178"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cang observed that this particular political propaganda related to Jewish emigration had infiltrated even the inclusive Socialist Party (PPS) by the end of the 1930s."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-179"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" Cang cautioned that this “new tendency which seeks the solution of the Jewish problem by Jewish emigration should not be considered representative of the official policy and attitude of the PPS.” In fact, “the official party press has made it clear, in reply to objections by leaders of the Bund, that this view does not represent the party’s stand.” Ideas casting “integrated” Jews as the only Jews deserving of their roots in Poland should be seen, Cang reflected, as symptomatic “of the results which anti-Jewish propaganda has produced in influencing even some socialists to regard the mass of Jews as aliens and to consider mass emigration as the sole solution to the Jewish problem in Poland.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-180"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is clear that Cang considered calls for mass emigration as a distraction from more pressing issues and, for the most part, unlikely to improve the horrific economic and social situation of Polish life in the late 1930s. In his reporting on the 1937 World Zionist Organization Congress, Cang referenced a “plebiscite carried out by the anti-Jewish Warsaw afternoon paper "), _c('i', [_vm._v("Goniec")]), _vm._v(".” Regarding the situation in Mandate Palestine, the paper put a question to its readers: “Will an independent Palestine hasten Jewish emigration from Poland?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-181"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" In response to this question, 600 Poles and 978 Jews replied yes, and 16,272 Poles and 195 Jews said no. The vast majority of Polish Christians (albeit ones reading a known antisemitic paper) did not believe that Jewish emigration could be hastened even in the wake of such a drastic development. Arguably, a majority of Christian readers of an “anti-Jewish” paper realized how rooted Polish Jews were in Polish society. The situation of German Jews, Joel Cang realized during the course of his reporting, was a different story entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the end of the 1930s, German Jews and in fact all Jews living in the Third Reich encountered a violent uprooting. One of the “chief objectives of Nazi policies towards the Jews between 1935 and September 1939,” Marion Kaplan writes, “had been to foster emigration, once called ‘the territorial solution.’”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-182"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" From the “Syrian” and “Ecuador” Projects to the “Madagascar Plan” and the “Haavara Transfer,” from 1933 onward the Nazi government devised plans “to "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("deposit Germany’s unwanted Jews around the globe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-183"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])]), _vm._v(" These statewide initiatives dovetailed with government support for individual emigration to create an atmosphere of forced expulsion. Even before they left Germany, thousands of German Jews found themselves on the move, often leaving smaller towns for the anonymity of the larger city. Cang traveled to Danzig in 1935 to witness this firsthand."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-184"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" Between 270,000 and 300,000 Jews managed to flee Germany overall from 1933 to 1939, and 1933 and 1938 marked the years with the highest exit numbers."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-185"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])]), _vm._v(" The “first waves of refugees fled to neighboring countries, probably hoping to return home at some point or to continue abroad if necessary,” and the “proportion of the total number of emigrations who fled overseas grew dramatically as the conditions in Europe worsened in the late 1930s” (especially after Kristallnacht)."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-186"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" Between 50,000 and 60,000 German Jews left Europe for the Palestinian Mandate in the 1930s."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-187"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon, the experience of Polish Jews living inside and outside the borders of the Second Republic dovetailed with the uprootedness plaguing German Jews. Cang first alerted readers of the "), _c('i', [_vm._v("Jewish Chronicle")]), _vm._v(" to the difficult situation facing Polish Jews living abroad on March 26, 1938, about two weeks after the Anschluss, which had brought 200,000 Austrian Jews into the Reich. He noted that upward of “20,000 Polish Jews living abroad would soon find themselves without a country.” Half a year later, after the Munich Agreement and just before Kristallnacht, Cang’s horrifying prediction rang true when at the end of October 1938 the "), _c('i', [_vm._v("Polenaktion")]), _vm._v(" began. On the night of October 27–28, police authorities detained fifteen to seventeen thousand Jewish citizens of Poland; rescinded their German residence permits; transported the detained Jews, including children separated from their parents, to the German-Polish border; and unloaded them there, making them walk the rest of the way to the border.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cang zoomed in on Zbąszyń, where the family of Herschel Grynszpan was caught in no-man’s-land after being expelled from Hanover along with 481 other Jewish citizens of Poland."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-188"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" From the end of October to the end of December 1938, Cang filed biweekly updates on the situation of Polish Jews within Germany as well as those expelled from there. Cang documented the brutal tactics utilized by the Germans, rumors of disease in the refugee camps, the high incidence of suicide among the deportees, and the slow deliberations between the Polish and German governments, which kept Jews confined to spaces in towns such as Zbąszyń for months on end."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-189"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" Cang reached out to his editor at the "), _c('i', [_vm._v("Manchester Guardian")]), _vm._v(" that November to see if that paper could offer him some form of permanent employment if he and his family had to flee Poland themselves. They did not, but he was officially appointed as a foreign "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("correspondent for the "), _c('i', [_vm._v("Manchester Guardian")]), _vm._v(" in 1938 after being denied such a status in 1932."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-190"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])]), _vm._v(" The journalist’s professional rise coincided with more precarious circumstances for Polish Jews, inside, outside, and on the state’s borders. In an increasing number of cases, rootedness had acquired both tragic and pessimistic undertones by 1938 and 1939."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-191"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" It entailed severe implications for Polish Jews living outside Poland and increasingly demanded more coverage, and a new word pervaded Cang’s writings by late 1938 and 1939: "), _c('i', [_vm._v("expulsions")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In less than a year, Joel Cang would learn about rootlessness himself. In September 1939, as his city of Warsaw fell to the Wehrmacht, he fled with his wife, Bela, and three-year-old son, Stefan, and traveled for ten days by train and foot until they arrived in Bucharest. From there, they traveled to England, where our story reconnects with him in 1946. In fact, many of the voices encountered in this chapter (Tartakower, Lestschinsky, Goldmann, Apenszlak, Perlzweig, Kubowitzki and others) experienced rootlessness at the end of the 1930s as well. As we move forward across this pivotal decade, we question how their own uprooting impacted their opinions of Jewish rootedness in Poland, east central Europe, and beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By the end of 1938 and the beginning of 1939, even some Polish Jews living elsewhere found themselves inextricably tethered to Poland. The expulsion of thousands of “Polish” Jews from Germany made some Polish Jews already in Poland more aware of their commitment to their community and their country. Arieh Tartakower, who vigorously wrote and spoke in favor of Jewish emigration away from Poland, swore that Poland’s Jews would “never” leave for political reasons alone, even if they were destined for Palestine."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-192"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" A colleague who contributed to the three-volume history of the Jews in Poland that Tartakower had edited expressed similar sentiments. Emanuel Ringelblum, a young historian based in Warsaw, volunteered with the JDC to assist the evacuees in Zbąszyń and elsewhere in 1938 and 1939. His travels all over Poland “showed him the immense determination of Polish Jewry to hold and defend itself against economic anti-semitism.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-193"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same month that Ringelblum penned his letter, May 1939, Jabotinsky announced to Warsaw reporters covering his travels throughout eastern Europe that his “evacuation plan had failed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-194"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])]), _vm._v(" Especially in the wake of the 1939 White Paper further restricting movement into Palestine, Polish Jews simply could not and, it appears, would not leave en masse for the Mandate or anywhere else. In 1938 and 1939, the United States did not even fill the immigration quota "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("designated for Polish citizens. To make life in Poland even more palatable for those who might want to leave, the first few months of 1939 saw the “highest rates of industrial growth since the years of inflation in the early 1920s” and a decline in antisemitism as political tensions between Poland and Germany began to rise."), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-195"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" Even in August 1939 as the Wehrmacht’s invasion of Poland loomed and a panicked flight of people in the western portions of the state began, Apolinary Hartglas, president of the General Zionist faction of the Zionist Organizations of Central and Eastern Poland, wrote that “to other than ideological motivated emigration to Palestine, we say no, never.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-196"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And, finally, two days after Chaim Weizmann dismissed the 576 delegates from the 1939 meeting of the World Zionist Organization in Switzerland, Zorach Warhaftig traveled with his wife and his friends on a sealed train back to Poland so that he could help defend his city and the city of his wife’s parents: Warsaw. We encountered Warhaftig briefly in this first chapter when he attended a meeting in advance of the WJC-sponsored campaign to elect representatives to speak on behalf of Polish Jews. He becomes an important personality in our story moving forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For now, we should note what he wrote about the summer of 1939 nearly six decades later. Warhaftig remembered that “only a few” members of the Polish delegation to the congress “opted to remain in Switzerland” rather than quickly return to a country soon to be invaded by the Wehrmacht. For Warhaftig, this was inconceivable. He recalled that “no such thought crossed my mind or that of my wife. We knew that we simply had to get back to our families in Warsaw and do our duty as loyal Polish citizens. At no time in the past had our Jewish and civil responsibilities coincided so harmoniously as they did [then], when . . . confronted with the menace of Hitler’s Nazi hordes.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "rfn1-197"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253064967_Notes#fn1-197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon, however, the uprootedness that marked German Jews in the 1930s would reshape the lives of Polish Jews and millions of other Polish citizens. That story of displacement linked to war, occupation, flight, and genocide is well known. Another story of uprooting, a story about the intellectual uprooting of the Jewish diaspora native to Poland and the region around it, coincides with this more obvious physical one and continues next.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9b49c30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253064967_Chapter01.vue
// module id = 87
// module chunks = 0